// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.auto-grow-textarea-container textarea[data-v-ad3993e8] {\r\n  min-height: 50px; /* Initial minimum height */\r\n  min-width: 100px; /* Initial minimum width */\r\n  overflow: hidden; /* Hide scrollbar */\r\n  resize: none; /* Disable resizing */\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
